import styled from 'styled-components';
import c from '../../utils/constants';

export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const P = styled.p`
  color: ${c.danger};
  font-size: 1em;
  padding: 1em;
  text-align: center;
`;
export const Header = styled.div`
  margin-top: 1em;
  margin-bottom: 0.5em;
`;
